var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{attrs:{"value":_vm.localValue,"type":"text"},on:{"input":_vm.onInput,"keypress":_vm.onlyNumbers,"paste":_vm.handlePaste}})}
var staticRenderFns = []

export { render, staticRenderFns }